import { render } from "./YoutubeVideoWithModal.vue?vue&type=template&id=2a01a767&scoped=true"
import script from "./YoutubeVideoWithModal.vue?vue&type=script&lang=js"
export * from "./YoutubeVideoWithModal.vue?vue&type=script&lang=js"

import "./YoutubeVideoWithModal.vue?vue&type=style&index=0&id=2a01a767&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a01a767"]])

export default __exports__